import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { DrawerContext, Colors } from '@notino/react-styleguide';

import { IVariantsProps as ICommonVariantsProps } from '@containers/ProductDetailContainer/model';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetail/ProductDetailContext';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { HorizontalChevron } from '@sharedComponents/Icons/HorizontalChevron';

import { VARIANT_CHEVRON_SIZE } from './constants';
import { messages } from './messages';
import {
  Button,
  Title,
  VariantInfo,
  ChevronWrapper,
  AdditionalInfo,
  ShadesVariantsList,
  ButtonColorCircle,
} from './styled';
import {
  trackDrawerOpen,
  trackResizeToTop,
  trackResizeToMiddle,
  trackDrawerClose,
} from './tracking';
import { getItemColors } from './utils';
import { ColorCirclePicker } from './VariantColorListItem';

export const VariantsShadesDrawer: React.FC<ICommonVariantsProps> = ({
  variants,
  selectedId,
  selectedVariant,
}) => {
  const { openDrawer, closeDrawer } = DrawerContext.useDrawerContext();
  const { getTimeFromInit: getTime } = useTrackingContext();
  const { product } = useProductDetailContext();

  const handleOpenDrawer: React.MouseEventHandler<HTMLButtonElement> = () => {
    trackDrawerOpen({ timing: getTime() });
    openDrawer(
      <ShadesVariantsList>
        {variants.map((item) => (
          <ColorCirclePicker
            item={item}
            isSelected={item.id === selectedId}
            key={item.id}
            getTimeFromInit={getTime}
            product={product}
          />
        ))}
      </ShadesVariantsList>,
      {
        title: (
          <Title>
            <FormattedMessage {...messages.pickVariant} />
          </Title>
        ),
        interceptBrowserBackButtonToCloseDrawer: true,
        onClose: (closeType) => {
          trackDrawerClose({ closeType, timing: getTime() });
          closeDrawer();
        },
        onResizeToTop: () => trackResizeToTop({ timing: getTime() }),
        onResizeToMiddle: () => trackResizeToMiddle({ timing: getTime() }),
      }
    );
  };

  return (
    <div id="pdVariantsColorPicker">
      <Button onClick={handleOpenDrawer} aria-expanded={false}>
        <VariantInfo>
          <ButtonColorCircle
            width={2}
            height={2}
            colors={getItemColors(selectedVariant)}
          />
          <AdditionalInfo>{selectedVariant.additionalInfo}</AdditionalInfo>
          <ChevronWrapper>
            <HorizontalChevron
              isOpened={false}
              width={VARIANT_CHEVRON_SIZE}
              height={VARIANT_CHEVRON_SIZE}
              color={Colors.neutralDarker}
            />
          </ChevronWrapper>
        </VariantInfo>
      </Button>
    </div>
  );
};
